var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54019 13.541H18.7441L11.228 21.0611C10.6273 21.6621 10.6273 22.6483 11.228 23.2493C11.8287 23.8503 12.799 23.8503 13.3996 23.2493L23.5495 13.0942C24.1502 12.4932 24.1502 11.5223 23.5495 10.9214L13.415 0.75079C12.8144 0.149802 11.8441 0.149802 11.2434 0.75079C10.6427 1.35178 10.6427 2.3226 11.2434 2.92359L18.7441 10.4591H1.54019C0.693085 10.4591 0 11.1525 0 12C0 12.8476 0.693085 13.541 1.54019 13.541Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.4441c5c5353bc05e023d8cc9a77edf2e.svg";
export { ForwardRef as ReactComponent };